import React from "react";
import Hero from "../components/home-sections/hero-section/Hero";
import MyDirective from "../components/home-sections/my-diretive-section/MyDirective";
const Home = () => {
  return (
    <div>
      <Hero />
      <MyDirective />
    </div>
  );
};

export default Home;
